#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"
#import "~/graphql/fragments/assets/defaultImageAsset.graphql"

fragment eventPageContent on events_default_Entry {
    title
    uri
    parent {
        title
        uri
    }
    image {
        ... DefaultImageAsset
    }
    video: videoUrl
    tags: selectEventType {
        title
    }
    startDate: plainDate
    endDate: plainDate2
    showNewsletterSubscribe
    flexibleSections {
        ... flexibleSections
    }
    seo {
        ... socialFragment
    }
}
